import BaseAPIService from '../base/base-api-service';
import CreditLimitModel from 'src/model/creditLimit.model';

class CreditLimitService extends BaseAPIService<CreditLimitModel> {
  public endpoint: string = '/accountapp/v1/email';

  constructor() {
    super(CreditLimitModel);
  }

  public increaseCreditLimit(
    accountNumber: string,
    companyName: string,
    email: string,
    message: string,
    mobileNumber: string,
    name: string
  ) {
    return new Promise((resolve, reject) => {
      this.doRequest({
        baseURL: this.baseURL,
        method: 'POST',
        url: `${this.endpoint}/creditLimitIncrease`,
        data: {
          accountNumber,
          companyName,
          email,
          message,
          mobileNumber,
          name
        }
      })
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  }
}

const creditLimitServiceInstance = new CreditLimitService();
Object.freeze(creditLimitServiceInstance);

export default creditLimitServiceInstance;
